import { Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts/dist/react-apexcharts.cjs.js'

const TargetBarChart = React.memo(({ graph_id = '', graph_data = [] }) => {

    const [isLoading, setIsLoading] = useState(true)

    const transformedData = graph_data?.map(item => ({
        x: item?.xAxis_date,
        y: item?.yAxis_service_done,
        goals: [
            {
                name: 'Service Target',
                value: item?.yAxis_service_target,
                strokeWidth: 5,
                strokeColor: '#775DD0',
            },
        ],
    }))

    const chartOptions = {
        chart: {
            id: graph_id || 'barchart',
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '50%',
                endingShape: 'rounded',
            },
        },
        colors: ['#00E396'],
        xaxis: {
            type: 'category',
            categories: graph_data?.map(item => item?.xAxis_date),
            labels: {
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                },
                formatter: value => `${value}`,
            },
        },
        tooltip: {
            theme: 'dark',
        },
        legend: {
            show: true,
            fontSize: '10px',
            markers: {
                fillColors: ['#00E396', '#775DD0'],
            },
        },
        grid: {
            show: false,
            borderColor: '#e5e5e5',
        },
        dataLabels: {
            enabled: false,
        },
    }

    const chartSeries = [
        {
            name: 'Service Done',
            data: transformedData,
        },
    ]

    useEffect(() => {
        if (chartSeries.length) {
            const timeout = setTimeout(() => setIsLoading(false), 500)
            return () => clearTimeout(timeout)
        }
    }, [chartSeries])

    return (
        <>
            <div
                style={{
                    overflow: "hidden",
                    width: '100%',
                    height: "100%"
                }}
            >
                {isLoading ? (
                    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Spin size='large' />
                    </div>
                ) : (
                    <div
                        style={{
                            height: "100%",
                            width: "100%",
                            overflow: "scroll",
                            whiteSpace: "nowrap",
                        }}
                    >

                        <Chart
                            options={chartOptions}
                            series={chartSeries}
                            type="bar"
                            height="100%"
                        />
                    </div>
                )}
            </div>
        </>
    )
})

export default TargetBarChart
